import { NotificationMessage } from '@gravitate-js/excalibrr'
import { getAPIURL } from '@utils/api'
import { getCurrentMarket, setCurrentMarket } from '@utils/general'
import axios from 'axios'
import _ from 'lodash'
import { message } from 'antd'
export const wrapInPromise = (fetchedData) => {
  const resp = new Promise((resolve) => resolve({ data: fetchedData }))
  return resp
}

export const responseErrorHandler = async (resp) => {
  try {
    if (!resp || resp?.message === 'Failed to fetch') {
      NotificationMessage('Oops!', 'Something unexpected happened. If this issue continues, please contact support.')
      return
    }

    const errData = await resp.json()

    if (resp.status === 300 && resp.url?.includes('bol/order_movements')) {
      localStorage.setItem('orderMovements_redirected_order_number', errData?.detail?.order_number)
      localStorage.setItem('orderMovements_redirected_market', errData?.detail?.redirect_market)

      setCurrentMarket(errData?.detail?.redirect_market)
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('order_number', errData?.detail?.order_number)
      window.location.search = searchParams.toString()
      return
    }
    if (resp.status === 422) {
      await handle422Errors(errData, resp)
    } else if (resp.status === 500) {
      NotificationMessage('Oops!', 'Something unexpected happened. If this issue continues, please contact support.')
    } else if (errData.detail === 'Not enough scopes for this endpoint') {
      NotificationMessage(
        'You are not allowed access. ',
        'if you feel this is a mistake, please contact your system administrator'
      )
    }
  } catch (error) {
    NotificationMessage('Oops.', 'Something unexpected happened. If this issue continues, please contact support.')
  }
}

export const handle422Errors = async (errData, resp) => {
  if (!errData.detail || !errData.detail.length) {
    NotificationMessage('422: No error details provided')
    return
  }

  if (!Array.isArray(errData.detail)) {
    NotificationMessage(`422: ${errData.detail}`)
    return
  }

  errData.detail.forEach((err) => {
    if (typeof err === 'string') {
      NotificationMessage(`422: ${err}`)
      return
    }

    if (err.loc && err.loc.length > 0) {
      err.loc.forEach((l, i) => {
        // first value will be "body", so we can skip that
        if (i === 0) return
        if (typeof l === 'number' && resp.url.includes('cards/upsert_many')) return
        const title = resp.url?.includes('cards/upsert_many') ? 'Update Blocked' : 'Oops!'
        let property = l.replace('_', ' ')
        property = property.charAt(0) + property.slice(1)
        NotificationMessage(title, `${property} - ${err.msg}`)
      })
    }
  })
}

export const setIdsOnRows = async (api, url, searchParams, returnsRows) => {
  if (returnsRows) {
    const rows = await api.post(url, undefined, {
      queryParams: new URLSearchParams(searchParams),
    })
    return rows?.map((row) => {
      row.id = crypto.randomUUID()
      return row
    })
  } else {
    const data = await api.post(url, searchParams)

    data.rows = data?.rows?.map((row) => {
      row.id = crypto.randomUUID()
      return row
    })
    return data
  }
}

/**
 *
 * @param {{data: *}} resp - Response data returned from Axios (or another async input)
 * @param { 'csv' | 'xlsx' } type - The type of sheet format to download in
 */
export const downloadSheetLocally = (resp, fileType, fileName) => {
  const contentDisposition = resp?.headers?.['content-disposition']
  const headerFileName = contentDisposition?.split('filename=')[1]?.replace(/"/g, '')

  const finalFileName = fileName ?? headerFileName?.split('.')[0] ?? 'results'
  const finalFileType = fileType ?? headerFileName?.split('.')[1] ?? 'xlsx'

  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(new Blob([resp.data]))
  link.setAttribute('download', `${finalFileName}.${finalFileType}`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadBlobAndLink = (response, fileName, successMessage) => {
  const blob = response.data
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()

  message.success(successMessage)
  return true
}
